const endpoints = {
  baseAddr: "https://proatend.cofness.com:8080/",
  login: "authenticate/",
  register: "register/",
  usuarios: "usuarios/",
  lojas: "lojas/",
  rotas: "rotas/",
  visitas: "visitas/",
  prod: "produtos/",
  pp: "produtosProprios/",
  pc: "produtosCompetidores/",
  logs: "logs/",
};

export default endpoints;
